import { render, staticRenderFns } from "./SupplierVerificationSection.vue?vue&type=template&id=58b6eb38&"
import script from "./SupplierVerificationSection.vue?vue&type=script&lang=js&"
export * from "./SupplierVerificationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports